
























































import './KisweModal.scss'
import { computed, defineComponent, onMounted, onUnmounted } from '@vue/composition-api'
import KisweButton from '@/modules/kisweui/components/KisweButton/KisweButton'
import KisweIcon from '@/modules/kisweui/components/KisweIcon'
import { useSizes } from '../../compositions'
import { KisweModalMode, KisweSize, KisweTheme } from '../../types'

export default defineComponent({
  name: 'Modal',
  components: {
    KisweButton,
    KisweIcon
  },
  props: {
    title: {
      type: String as () => string|null,
      required: false,
      default: null
    },
    mode: {
      type: String as () => KisweModalMode,
      required: false,
      default: () => KisweModalMode.None
    },
    customClass: {
      type: String,
      required: false,
      default: ''
    },
    labelSubmit: {
      type: String as () => string|null,
      required: false,
      default: null
    },
    isCloseOnOutside: {
      type: Boolean,
      required: false,
      default: true
    },
    isCloseVisible: {
      type: Boolean,
      required: false,
      default: false
    },
    isCancelVisible: {
      type: Boolean,
      required: false,
      default: true
    },
    isSubmitVisible: {
      type: Boolean,
      required: false,
      default: true
    },
    isSubmitDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    isSubmitLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    buttonTheme: {
      type: String as () => KisweTheme,
      required: false,
      default: () => KisweTheme.Primary,
      validator: (value: KisweTheme) => Object.values(KisweTheme).includes(value)
    },
    buttonSize: {
      type: String as () => KisweSize,
      required: false,
      default: () => KisweSize.Small,
      validator: (value: KisweSize) => Object.values(KisweSize).includes(value)
    },
    ...useSizes().props
  },
  emits: {
    close () { return true },
    submit () { return true }
  },
  // eslint-disable-next-line max-lines-per-function
  setup (props, { emit }) {
    const close = () => emit('close')
    const closeOnOutside = () => {
      if (!props.isCloseOnOutside) return
      close()
    }
    const submit = () => emit('submit')
    const onKeyDown = (e: Event) => (e instanceof KeyboardEvent && e.key === 'Escape') && close()

    const labelSubmitButton = computed(() => {
      if (props.labelSubmit !== null) return props.labelSubmit
      switch (props.mode) {
        case KisweModalMode.Create: return 'Create'
        case KisweModalMode.Read: return 'Close'
        default: return 'Save'
      }
    })

    const labelCancelButton = computed(() => {
      switch (props.mode) {
        case KisweModalMode.Read: return 'Close'
        default: return 'Cancel'
      }
    })

    onMounted(() => window.document.addEventListener('keydown', onKeyDown))
    onUnmounted(() => window.document.removeEventListener('keydown', onKeyDown))

    return {
      close,
      closeOnOutside,
      labelCancelButton,
      labelSubmitButton,
      submit
    }
  },
  computed: {
    isFooterVisible (): boolean {
      return !!this.$slots['footer-buttons'] || this.isSubmitVisible || this.isCancelVisible
    }
  }
})
